import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "./App.jsx";
import { Toaster } from "react-hot-toast";
import "./index.css";
import { initSentry, initPosthog } from "./instrument";
import queryClient from "./queryClient";

initSentry();
initPosthog();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster />
    </QueryClientProvider>
  </React.StrictMode>
);
